import { KeyboardCode, pointerWithin, rectIntersection } from '@dnd-kit/core'

import { SYMBOL_HYPHEN } from '../../../constants/common'
import { REQUEST_MASS_ACTION_ID_KEY } from '../Request.constants.actions'

import { REQUEST_BOARD_DROPPABLE_ID_PREFIX } from './RequestBoard.constants'

function getRequestBoardKeyboardTargetRect({
  code,
  collisionRect,
  droppableRects,
}) {
  const center = collisionRect.left + collisionRect.width / 2

  const rects = [...droppableRects.values()].sort(
    (first, second) => first.left - second.left
  )

  switch (code) {
    case KeyboardCode.Right:
      return rects.find(rect => rect.left > center) ?? null
    case KeyboardCode.Left:
      return rects.filter(rect => rect.right < center).at(-1) ?? null
    default:
      return null
  }
}

function toRequestBoardItemRequestIds({ ids, requestId }) {
  return Object.fromEntries(ids.map(id => [id, requestId]))
}

export function getRequestBoardColumn({ columns, status }) {
  return columns.find(column => column.status === status)
}

export function removeRequestBoardId({ id, ids }) {
  return ids.filter(itemId => itemId !== id)
}

export function getRequestBoardItems(columns) {
  return columns.flatMap(column => column.items)
}

export function getRequestBoardItemFilters({ filterValues, id }) {
  return { ...filterValues, [REQUEST_MASS_ACTION_ID_KEY]: [id] }
}

export function getRequestBoardItemRequestIds({ ids, requestId, requestIds }) {
  return {
    ...requestIds,
    ...toRequestBoardItemRequestIds({ ids, requestId }),
  }
}

export function isRequestBoardItemRequestLatest({ id, requestId, requestIds }) {
  return requestIds[id] === requestId
}

export function getRequestBoardColumnDroppableId(status) {
  return [REQUEST_BOARD_DROPPABLE_ID_PREFIX, status].join(SYMBOL_HYPHEN)
}

export function getRequestBoardCollisions(args) {
  return args.pointerCoordinates ? pointerWithin(args) : rectIntersection(args)
}

export function getRequestBoardKeyboardCoordinates(
  event,
  { context: { collisionRect, droppableRects }, currentCoordinates }
) {
  const targetRect = collisionRect
    ? getRequestBoardKeyboardTargetRect({
        code: event.code,
        collisionRect,
        droppableRects,
      })
    : null

  return targetRect
    ? {
        x: targetRect.left + (targetRect.width - collisionRect.width) / 2,
        y: currentCoordinates.y,
      }
    : undefined
}

export function isRequestBoardOverDroppable(dropStatus) {
  return dropStatus !== null
}

// A column whose list failed keeps its Retry: a card dropped there would hide it.
export function isRequestBoardColumnDropDisabled({ column, draggedStatus }) {
  return column.status === draggedStatus || column.isLoading || column.hasError
}

export function isRequestBoardCardStatusEditable(item) {
  return Boolean(item.permissions?.can_edit_status)
}

export function isRequestBoardCardPending({ item, pendingIds }) {
  return pendingIds.includes(item.id)
}

export function isRequestBoardCardDraggable({ item, pendingIds }) {
  return (
    isRequestBoardCardStatusEditable(item) &&
    !isRequestBoardCardPending({ item, pendingIds })
  )
}
